'use client';
"use strict";

var _excluded = ["htmlSize"],
  _excluded2 = ["children", "className"],
  _excluded3 = ["placement"],
  _excluded4 = ["placement"],
  _excluded5 = ["className"],
  _excluded6 = ["className"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Input: function Input() {
    return _Input;
  },
  InputAddon: function InputAddon() {
    return _InputAddon;
  },
  InputGroup: function InputGroup() {
    return _InputGroup;
  },
  InputLeftAddon: function InputLeftAddon() {
    return _InputLeftAddon;
  },
  InputLeftElement: function InputLeftElement() {
    return _InputLeftElement;
  },
  InputRightAddon: function InputRightAddon() {
    return _InputRightAddon;
  },
  InputRightElement: function InputRightElement() {
    return _InputRightElement;
  },
  useInputGroupStyles: function useInputGroupStyles() {
    return _useInputGroupStyles;
  }
});
module.exports = __toCommonJS(src_exports);

// src/input.tsx
var import_form_control = require("@chakra-ui/form-control");
var import_system = require("@chakra-ui/system");
var import_shared_utils = require("@chakra-ui/shared-utils");
var import_jsx_runtime = require("react/jsx-runtime");
var _Input = (0, import_system.forwardRef)(function Input2(props, ref) {
  var htmlSize = props.htmlSize,
    rest = _objectWithoutProperties(props, _excluded);
  var styles = (0, import_system.useMultiStyleConfig)("Input", rest);
  var ownProps = (0, import_system.omitThemingProps)(rest);
  var input = (0, import_form_control.useFormControl)(ownProps);
  var _className = (0, import_shared_utils.cx)("chakra-input", props.className);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.input, _objectSpread(_objectSpread({
    size: htmlSize
  }, input), {}, {
    __css: styles.field,
    ref: ref,
    className: _className
  }));
});
_Input.displayName = "Input";
_Input.id = "Input";

// src/input-addon.tsx
var import_system3 = require("@chakra-ui/system");
var import_shared_utils3 = require("@chakra-ui/shared-utils");

// src/input-group.tsx
var import_react_context = require("@chakra-ui/react-context");
var import_react_children_utils = require("@chakra-ui/react-children-utils");
var import_system2 = require("@chakra-ui/system");
var import_shared_utils2 = require("@chakra-ui/shared-utils");
var import_object_utils = require("@chakra-ui/object-utils");
var import_react = require("react");
var import_jsx_runtime2 = require("react/jsx-runtime");
var _ref = (0, import_react_context.createContext)({
    name: "InputGroupStylesContext",
    errorMessage: "useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<InputGroup />\" "
  }),
  _ref2 = _slicedToArray(_ref, 2),
  InputGroupStylesProvider = _ref2[0],
  _useInputGroupStyles = _ref2[1];
var _InputGroup = (0, import_system2.forwardRef)(function InputGroup2(props, ref) {
  var styles = (0, import_system2.useMultiStyleConfig)("Input", props);
  var _ref3 = (0, import_system2.omitThemingProps)(props),
    children = _ref3.children,
    className = _ref3.className,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  var _className = (0, import_shared_utils2.cx)("chakra-input__group", className);
  var groupStyles = {};
  var validChildren = (0, import_react_children_utils.getValidChildren)(children);
  var input = styles.field;
  validChildren.forEach(function (child) {
    var _a, _b;
    if (!styles) return;
    if (input && child.type.id === "InputLeftElement") {
      groupStyles.paddingStart = (_a = input.height) != null ? _a : input.h;
    }
    if (input && child.type.id === "InputRightElement") {
      groupStyles.paddingEnd = (_b = input.height) != null ? _b : input.h;
    }
    if (child.type.id === "InputRightAddon") {
      groupStyles.borderEndRadius = 0;
    }
    if (child.type.id === "InputLeftAddon") {
      groupStyles.borderStartRadius = 0;
    }
  });
  var clones = validChildren.map(function (child) {
    var _a, _b;
    var theming = (0, import_object_utils.compact)({
      size: ((_a = child.props) == null ? void 0 : _a.size) || props.size,
      variant: ((_b = child.props) == null ? void 0 : _b.variant) || props.variant
    });
    return child.type.id !== "Input" ? (0, import_react.cloneElement)(child, theming) : (0, import_react.cloneElement)(child, Object.assign(theming, groupStyles, child.props));
  });
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.div, _objectSpread(_objectSpread({
    className: _className,
    ref: ref,
    __css: _objectSpread({
      width: "100%",
      display: "flex",
      position: "relative",
      // Parts of inputs override z-index to ensure that they stack correctly on each other
      // Create a new stacking context so that these overrides don't leak out and conflict with other z-indexes
      isolation: "isolate"
    }, styles.group),
    "data-group": true
  }, rest), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)(InputGroupStylesProvider, {
      value: styles,
      children: clones
    })
  }));
});
_InputGroup.displayName = "InputGroup";

// src/input-addon.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var placements = {
  left: {
    marginEnd: "-1px",
    borderEndRadius: 0,
    borderEndColor: "transparent"
  },
  right: {
    marginStart: "-1px",
    borderStartRadius: 0,
    borderStartColor: "transparent"
  }
};
var StyledAddon = (0, import_system3.chakra)("div", {
  baseStyle: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  }
});
var _InputAddon = (0, import_system3.forwardRef)(function InputAddon2(props, ref) {
  var _a;
  var _props$placement = props.placement,
    placement = _props$placement === void 0 ? "left" : _props$placement,
    rest = _objectWithoutProperties(props, _excluded3);
  var placementStyles = (_a = placements[placement]) != null ? _a : {};
  var styles = _useInputGroupStyles();
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(StyledAddon, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    __css: _objectSpread(_objectSpread({}, styles.addon), placementStyles)
  }));
});
_InputAddon.displayName = "InputAddon";
var _InputLeftAddon = (0, import_system3.forwardRef)(function InputLeftAddon2(props, ref) {
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(_InputAddon, _objectSpread(_objectSpread({
    ref: ref,
    placement: "left"
  }, props), {}, {
    className: (0, import_shared_utils3.cx)("chakra-input__left-addon", props.className)
  }));
});
_InputLeftAddon.displayName = "InputLeftAddon";
_InputLeftAddon.id = "InputLeftAddon";
var _InputRightAddon = (0, import_system3.forwardRef)(function InputRightAddon2(props, ref) {
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(_InputAddon, _objectSpread(_objectSpread({
    ref: ref,
    placement: "right"
  }, props), {}, {
    className: (0, import_shared_utils3.cx)("chakra-input__right-addon", props.className)
  }));
});
_InputRightAddon.displayName = "InputRightAddon";
_InputRightAddon.id = "InputRightAddon";

// src/input-element.tsx
var import_system4 = require("@chakra-ui/system");
var import_shared_utils4 = require("@chakra-ui/shared-utils");
var import_jsx_runtime4 = require("react/jsx-runtime");
var StyledInputElement = (0, import_system4.chakra)("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
});
var InputElement = (0, import_system4.forwardRef)(function InputElement2(props, ref) {
  var _a, _b;
  var _props$placement2 = props.placement,
    placement = _props$placement2 === void 0 ? "left" : _props$placement2,
    rest = _objectWithoutProperties(props, _excluded4);
  var styles = _useInputGroupStyles();
  var input = styles.field;
  var attr = placement === "left" ? "insetStart" : "insetEnd";
  var elementStyles = _objectSpread(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, attr, "0"), "width", (_a = input == null ? void 0 : input.height) != null ? _a : input == null ? void 0 : input.h), "height", (_b = input == null ? void 0 : input.height) != null ? _b : input == null ? void 0 : input.h), "fontSize", input == null ? void 0 : input.fontSize), styles.element);
  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(StyledInputElement, _objectSpread({
    ref: ref,
    __css: elementStyles
  }, rest));
});
InputElement.id = "InputElement";
InputElement.displayName = "InputElement";
var _InputLeftElement = (0, import_system4.forwardRef)(function InputLeftElement2(props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties(props, _excluded5);
  var _className = (0, import_shared_utils4.cx)("chakra-input__left-element", className);
  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(InputElement, _objectSpread({
    ref: ref,
    placement: "left",
    className: _className
  }, rest));
});
_InputLeftElement.id = "InputLeftElement";
_InputLeftElement.displayName = "InputLeftElement";
var _InputRightElement = (0, import_system4.forwardRef)(function InputRightElement2(props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties(props, _excluded6);
  var _className = (0, import_shared_utils4.cx)("chakra-input__right-element", className);
  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(InputElement, _objectSpread({
    ref: ref,
    placement: "right",
    className: _className
  }, rest));
});
_InputRightElement.id = "InputRightElement";
_InputRightElement.displayName = "InputRightElement";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Input: _Input,
  InputAddon: _InputAddon,
  InputGroup: _InputGroup,
  InputLeftAddon: _InputLeftAddon,
  InputLeftElement: _InputLeftElement,
  InputRightAddon: _InputRightAddon,
  InputRightElement: _InputRightElement,
  useInputGroupStyles: _useInputGroupStyles
});